import { Col } from "react-bootstrap";
import TeamMemberObjectivesList from "./TeamMemberObjectivesList";
import "./TeamMember.css";

function TeamMember({ id, name, objectives, language }) {
  return (
    <Col key={id} className="team-member-card mb-4">
      <Col>
        <h5>{name}</h5>
      </Col>
      <Col>
        <TeamMemberObjectivesList objectives={objectives} language={language} />
      </Col>
    </Col>
  );
}

export default TeamMember;
